import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import v3Image from "../../assets/DoorAccess/g3-starter-kit-pro.jpg";
import image from "../../assets/product-list-assets/cameras/door-access/g3-starter-kit-pro.jpg";
import type { Product } from "../../types";
import { starterKits } from "../product-list-groups/starterKits";
import {
  includedAccessories,
  includedHub,
  includedReaders,
  touchPassSupport,
} from "../properties";

export const g3StarterKitPro: Product = {
  id: "g3StarterKitPro",
  productTitle: "G3 Starter Kit Pro",
  description: "g3StarterKitPro.description",
  productListGroup: starterKits,
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.DoorAccess}/ua-g3-sk-pro`,
  ],
  storePathParts: {
    category: UniFiChildCategorySlug.DoorAccessStarterKit,
    productSlug: "ua-g3-sk-pro",
  },
  image: { src: image, width: 200, height: 160 },
  v3Image: {
    src: v3Image,
    width: 327,
    height: 182,
  },
  isNew: true,
  propertyValues: [
    {
      propertyId: includedHub.id,
      value: {
        type: "translation",
        value: "g3StarterKitPro.includedHub",
      },
    },
    {
      propertyId: includedReaders.id,
      value: {
        type: "translation",
        value: "g3StarterKitPro.includedReaders",
      },
    },
    {
      propertyId: includedAccessories.id,
      value: {
        type: "translation",
        value: "g3StarterKitPro.includedAccessories",
      },
    },
    {
      propertyId: touchPassSupport.id,
      value: {
        type: "string",
        value: "Apple Wallet\nGoogle Wallet",
      },
    },
  ],
};
